// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_4w-7";
export var adjustableWidthBorderHeld = "_4w-8";
export var arrow = "_4w-3";
export var arrowButton = "_4w-4";
export var headerCell = "_4w-0";
export var help = "_4w-2";
export var icon = "_4w-1";
export var iconWrapper = "_4w-6";
export var noBorder = "_4w-b";
export var nonAdjustableWidthBorder = "_4w-9";
export var nonAdjustableWidthBorderHeld = "_4w-a";
export var textButton = "_4w-5";